module.exports = __webpack_public_path__ + "img/1515268845.c6cc1385.jpg";